/* 棋盘动画 */
import { Canvas, dep, DisplayObject, Filter, getDefaults } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters, Action } from '../../anim-constants';
import _ceil from 'lodash/ceil';
import { IAnimFilterOptions } from '../../anim-interface';

export default class CheckerboardFilter extends Filter {
    public static defaults: IAnimFilterOptions = {
        rate: 0,
        direction: PresetSubtype.Across,
        action: Action.ENTR,
    };

    @dep public rate: number;
    @dep public direction = PresetSubtype.Across;
    @dep public action = Action.ENTR;

    public forbidWebgl = true;
    public type = AnimFilters.CHECKERBOARD;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super();
        const defaults = getDefaults<typeof CheckerboardFilter>(this);
        this.rate = options.rate ?? defaults.rate;
        this.direction = options.direction ?? defaults.direction;
        this.action = options.action ?? defaults.action;
    }

    public apply(obj: DisplayObject, canvas: Canvas) {
        this.direction === PresetSubtype.Across
            ?  this.applyAcross(canvas) : this.applyDown(canvas);
    }

    /**
     * 横跨棋盘
     * @param canvas
     */
    protected applyAcross(canvas: Canvas) {
        const { width, height } = canvas;
        const averageWidth = width / 6;
        const averageHeight = height / 6;
        const ceilAverHeight = _ceil(averageHeight);
        const sliceWidth = this.rate * averageWidth;
        const isEntr = this.isEntr();
        const { y, x } = canvas.bounds;
        const filterWidth = isEntr ?   averageWidth - sliceWidth : sliceWidth;
        for (let row = 0; row < 6; row ++) {
            const offsetY = averageHeight * row;
            for (let col = 0; col < 7; col++) {
                let offsetX = isEntr ? (averageWidth * col) + sliceWidth : (averageWidth * (col + 1)) - sliceWidth ;
                // 奇数行左移 1/2 个单位
                offsetX = row % 2 ? offsetX - (averageWidth / 2) : offsetX;
                canvas.clearRect(offsetX + x, offsetY + y, filterWidth, ceilAverHeight);
            }
        }
    }

    /**
     * 向下棋盘
     * @param canvas
     */
    protected applyDown(canvas: Canvas) {
        const { width, height } = canvas;
        const averageWidth = width / 6;
        const ceilAverWidth = _ceil(averageWidth);
        const averageHeight = height / 6;
        const slideHeight = this.rate * averageHeight;
        const isEntr = this.isEntr();
        const { y, x } = canvas.bounds;
        const filterHeight = isEntr ?   averageHeight - slideHeight : slideHeight;
        for (let col = 0; col < 6; col++) {
            const offsetX = averageWidth * col;
            for (let row = 0; row < 7; row++) {
                let offsetY = isEntr ? (averageHeight * row) + slideHeight : (averageWidth * (row + 1)) - slideHeight ;
                // 奇数列上移 1/2 个单位
                offsetY = col % 2 ? offsetY - (averageHeight / 2) : offsetY;
                canvas.clearRect(offsetX + x, offsetY + y, ceilAverWidth, filterHeight);
            }
        }
    }

    protected isEntr = () => this.action === Action.ENTR;
}
